import { IFormConfigResult } from "../services/contextService";
import IFormDefinition from "../interfaces/IFormDefinition";
import { base64ToJson } from "../utils/json.helpers";

const FormDefinitionMapper = {
    apiToDomain: (api: IFormConfigResult["lomakemaaritys"]): IFormDefinition => {
        return {
            id: api.id,
            name: api.nimi,
            category: api.kategoria,
            workflow: api.tyonkulku,
            schema: base64ToJson(api.data)
        }
    },
};

export default FormDefinitionMapper
